import Vue from 'vue';
import types from '../../mutation-types';

const setLeadRecord = (records, lead) => {
  Vue.set(records, lead.cnpj, {
    ...(records[lead.cnpj] || {}),
    ...lead,
  });
};

export const mutations = {
  [types.SET_FLIP_LEADS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_FLIP_LEADS]($state) {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_FLIP_LEADS]($state, data = []) {
    $state.sortOrder = data.map(lead => {
      setLeadRecord($state.records, lead);
      return lead.cnpj;
    });
  },

  // "Carregar mais" ACRESCENTA. O de-duplicador nao e zelo: dois ramos do UNION ALL podem
  // empatar em score e o cursor reentrega a linha de fronteira — sem isso a mesma empresa
  // aparece duas vezes na lista.
  [types.APPEND_FLIP_LEADS]($state, data = []) {
    const novos = data.filter(lead => !$state.sortOrder.includes(lead.cnpj));
    novos.forEach(lead => setLeadRecord($state.records, lead));
    $state.sortOrder = $state.sortOrder.concat(novos.map(lead => lead.cnpj));
  },

  [types.SET_FLIP_LEADS_META]($state, data = {}) {
    const {
      total = 0,
      exact = true,
      status = 'ok',
      next_cursor: nextCursor = null,
      depth_cap: depthCap = null,
    } = data;
    Vue.set($state, 'meta', { total, exact, status, nextCursor, depthCap });
  },

  // O reveal cobra credito e devolve o contato aberto. Remendar o registro aqui e o que faz a
  // volta do detalhe para a lista mostrar o que a conta acabou de pagar, em vez de repetir a
  // mascara e sugerir que o dinheiro nao comprou nada.
  [types.SET_FLIP_LEAD_ITEM]($state, data) {
    if (!data || !data.cnpj) return;
    setLeadRecord($state.records, data);
  },

  // A ALLOWLIST COMIA OS SINAIS DE CAPACIDADE, e isso era um defeito: `divida_disponivel` sai do
  // servidor (`SearchQuery#facets`) desde a #836 e nunca chegava à tela, então
  // `SearchView.dividaDisponivel` (`!== false`) respondia `true` em toda base, inclusive nas que
  // não cruzaram a PGFN — os chips ficavam acesos e a busca respondia 422. Os specs não pegavam
  // porque escrevem o getter à mão, pulando esta mutation.
  //
  // As duas chaves são BOOLEANOS e não listas, então o default aqui é `undefined` e não `[]`: é
  // ele que a tela lê como "ainda não sei" enquanto a primeira chamada de facetas não volta.
  // `porte_real` continua de fora de propósito — ninguém a desenha ainda (#832 a criou no
  // servidor); acrescentá-la é assunto de quem for usá-la.
  // DUAS ESPECIES DE DADO NUMA CHAVE SO, e elas se comportam ao contrario uma da outra.
  //
  // As CONTAGENS (uf, classe_porte, cnae) descrevem o recorte pedido: uma resposta sem elas tem
  // de ZERAR o que estava na tela, senao o trilho segue mostrando os numeros de outro recorte.
  //
  // As CAPACIDADES (`divida_disponivel`, `cnae_secundaria_disponivel`) descrevem a BASE — se o
  // cruzamento com a PGFN rodou, se o swap da #681 aconteceu. Elas nao mudam de um request para
  // o outro, e uma resposta que nao as traz nao esta dizendo "nao ha": esta dizendo nada. E a
  // faceta responde SEM elas em dois casos reais — o timeout do servidor (200 com `payload: {}`)
  // e o `SET_FLIP_LEADS_FACETS({})` com que a propria action trata falha de rede.
  //
  // Sobrescrever com `undefined` ali reabria o buraco que a #836 fechou: os computeds da
  // SearchView leem `!== false`, entao `undefined` volta a significar "disponivel", o chip de
  // divida reacende numa base sem o cruzamento e a busca ao lado responde 422. Por isso a
  // capacidade so muda quando a resposta REALMENTE traz a chave.
  [types.SET_FLIP_LEADS_FACETS]($state, data = {}) {
    const anterior = $state.facets || {};
    const capacidade = chave => (chave in data ? data[chave] : anterior[chave]);

    Vue.set($state, 'facets', {
      uf: data.uf || [],
      classe_porte: data.classe_porte || [],
      cnae: data.cnae || [],
      divida_disponivel: capacidade('divida_disponivel'),
      cnae_secundaria_disponivel: capacidade('cnae_secundaria_disponivel'),
    });
  },

  [types.SET_FLIP_LEADS_FILTERS]($state, data = {}) {
    $state.appliedFilters = data;
  },

  [types.SET_FLIP_LEADS_CREDITS]($state, data) {
    Vue.set($state, 'credits', data);
  },
};
